<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Process_Title' | translateWF: 'Processes' }}</h1>
        <div class="page__title_buttons">
          @if (canEdit()) {
            <p-button [label]="'Common_Add' | translateWF: 'Add'" icon="pi pi-plus" (click)="goToDetails('new')" />
          }
        </div>
      </div>
    </div>
    <section>
      <div class="cs-page-list-grid">
        @if (filterConfig() && showFilters()) {
          <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
        }

        <p-panel [header]="'Process_Title' | translateWF: 'Processes'">
          <ng-template pTemplate="icons">
            <p-button
              [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
              [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
              (click)="showFilters.set(!showFilters())"
              variant="outlined"
              size="small"
            />
          </ng-template>

          <p-card data-variant="compact">
            <p-table
              [value]="listProcesses()"
              [paginator]="true"
              [rows]="25"
              [rowsPerPageOptions]="[15, 25, 50]"
              [first]="firstPagination()"
              (onPage)="onPageChange($event)"
              selectionMode="single"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th pSortableColumn="processId">{{ 'Process_ID' | translateWF: 'Process ID' }}<p-sortIcon field="processId" /></th>
                  <th pSortableColumn="name">
                    {{ 'Process_Name' | translateWF: 'Name' }}
                    <p-sortIcon field="name" />
                  </th>
                  <th pSortableColumn="showInFabricGeneralProcessRoute">
                    {{ 'Process_Show_Route' | translateWF: 'Show In Fabric Route' }}
                    <p-sortIcon field="showInFabricGeneralProcessRoute" />
                  </th>
                  <th pSortableColumn="description">
                    {{ 'Process_Description' | translateWF: 'Description' }}
                    <p-sortIcon field="description" />
                  </th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-rowData let-index="rowIndex">
                @let process = getRowData(rowData);
                <tr class="cursor-pointer" (click)="goToDetails(process.processId)">
                  <td class="max-w-[12.5rem] truncate">
                    <a>{{ process.processId }}</a>
                  </td>
                  <td>{{ process.name.en }}</td>
                  <td>
                    @if (process.showInFabricGeneralProcessRoute) {
                      <i class="pi pi-check text-green-500"></i>
                    }
                  </td>
                  <td class="truncate max-w-[7.5rem]">
                    {{ process.description.en }}
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="4">
                    {{ 'Process_Not_Found' | translateWF: 'Processes not found' }}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </p-card>
        </p-panel>
      </div>
    </section>
  </div>
</main>
